var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{staticClass:"btn-shift-data ml-2",on:{"click":_vm.handleClicked}},[_c('font-awesome-icon',{staticClass:"icon-style",attrs:{"icon":"download"}}),_vm._v("\n  シフト表（Excel）\n")],1)}
var staticRenderFns = []

export { render, staticRenderFns }